/* tslint:disable */
/* eslint-disable */

/**
 * Oracle account codes:
 * - 4410050: TAXABLE_ITEMS
 * - 4410051: OUT_OF_SCOPE_ITEMS
 */
export enum OracleAccount {
  $4410050 = '4410050',
  $4410051 = '4410051',
}
